const FormWrapper = ({ children }) => {
  return <div className="container-memory-modal">{children}</div>;
};

export default FormWrapper;
